/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect, useRef } from "react";

export const HeaderSticky = ({ elementId = "header", stickyElementId = "header-sticky" }) => {
  const stickyRef = useRef(null);

  const makeSticky = (entries) => {
    const fixedClassName = "sticky";
    const headerClassList = document.getElementById(elementId) && document.getElementById(elementId).classList;
    const stickyClassList =
      document.getElementById(stickyElementId) && document.getElementById(stickyElementId).classList;
    if (headerClassList) {
      entries.forEach((entry) => {
        if (entry.rootBounds) {
          if (entry.isIntersecting) {
            headerClassList.remove(fixedClassName);
            stickyClassList.remove('sticky-placeholder');
            stickyClassList.remove('sticky-header-height');
          } else {
            headerClassList.add(fixedClassName);
            stickyClassList.add('sticky-placeholder');
            stickyClassList.add('sticky-header-height');
          }
        }
      });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(makeSticky, {});
    if (stickyRef.current) {
      observer.observe(stickyRef.current);
    }
    return () => {
      if (stickyRef.current) {
        observer.unobserve(stickyRef.current);
      }
    };
  }, []);

  return <div ref={stickyRef} />;
};
